// Initialiser le consentement avant tout chargement applicatif.
import "./bootstrap/consent-default.js";
import "./bootstrap/brevo-stub.js";
import "./bootstrap/app-loading.js";
import "@/styles/global.css";

let started = false;
const start = () => {
    if (started) return;
    started = true;
    void import("./bootstrap/render-app");
};
if (document.getElementById("root")?.dataset.rendered === "react") {
    // Donner la priorité au premier écran, sans retarder une interaction volontaire.
    const onInteraction = () => start();
    let pendingButton: HTMLButtonElement | null = null;
    const onClick = (event: MouseEvent) => {
        if (document.getElementById("root")?.dataset.hydrated === "true") return;
        const button = event.target instanceof Element ? event.target.closest<HTMLButtonElement>("#root button") : null;
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        pendingButton = button;
        start();
    };
    // Un clic pendant le téléchargement est exécuté dès que React est prêt.
    document.addEventListener("click", onClick, true);
    document.addEventListener("nahibu:ready", () => {
        document.removeEventListener("click", onClick, true);
        window.removeEventListener("pointerdown", onInteraction);
        window.removeEventListener("keydown", onInteraction);
        if (pendingButton?.isConnected) pendingButton.click();
    }, { once: true });
    window.addEventListener("pointerdown", onInteraction, { once: true, passive: true });
    window.addEventListener("keydown", onInteraction, { once: true });
    const poster = document.querySelector<HTMLImageElement>(".home-page > section picture img");
    const visible = () => {
        // Une image décodée n'est pas forcément peinte : laisser le navigateur afficher le HTML avant React.
        if (!("PerformanceObserver" in window) || performance.getEntriesByName("first-contentful-paint").length) {
            requestAnimationFrame(() => requestAnimationFrame(start));
            return;
        }
        const observer = new PerformanceObserver((list) => {
            if (!list.getEntries().some((entry) => entry.name === "first-contentful-paint")) return;
            observer.disconnect();
            start();
        });
        observer.observe({ type: "paint", buffered: true });
        // Les onglets masqués et les navigateurs sans mesure de peinture doivent aussi devenir interactifs.
        window.setTimeout(() => { observer.disconnect(); start(); }, 1000);
    };
    if (poster) void poster.decode().catch(() => {}).then(visible);
    else visible();
} else {
    start();
}
